export const textAreaFieldStyles = {
  '.MuiInputBase-input': {
    fontSize: '14px',
    padding: '12px',
  },
};

export const countryCodeInputStyles = {
  border: 'none',
  fontSize: '16px',
  borderRadius: '8px',
  height: '56px',
  padding: '17px 0px 17px 70px',
  boxShadow: 'none',
  width: '170px',
  caretColor: 'transparent',
};

export const countryCodeInputMobileStyles = {
  border: 'none',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  borderRadius: '8px',
  boxShadow: 'none',
  padding: '17px 14px 17px 60px',
  width: '105px',
  height: '54px',
  caretColor: 'transparent',
};
